'use client'

// Root error boundary — replaces the root layout when it throws, so it must
// render its own <html>/<body> and cannot rely on globals.css or providers.
// openspec: iso27001-soc2-readiness task 1.4
import { useEffect } from 'react'
import { reportError } from '@/lib/report-error'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    reportError(error, { boundary: 'app/global-error.tsx', digest: error.digest })
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#F8F5EE',
          color: '#1a1a1a',
          fontFamily:
            'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Noto Sans TC", sans-serif',
          padding: '24px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: 440,
            background: '#fff',
            border: '1px solid #e5e2da',
            borderRadius: 12,
            padding: 32,
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: 28, marginBottom: 12 }} aria-hidden="true">
            ⚠️
          </div>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: '0 0 8px' }}>
            Something went wrong / 發生錯誤
          </h1>
          <p style={{ fontSize: 14, color: '#6b6b6b', margin: '0 0 24px', lineHeight: 1.5 }}>
            StyTrix hit an unexpected error while loading. Retry, or reload the page. If it keeps happening,
            contact support and quote the reference below.
          </p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginBottom: 20 }}>
            <button
              type="button"
              onClick={reset}
              style={{
                background: '#EC6040',
                color: '#fff',
                border: 0,
                borderRadius: 8,
                padding: '8px 16px',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              重試 / Retry
            </button>
            <a
              href="/"
              style={{
                border: '1px solid #e5e2da',
                borderRadius: 8,
                padding: '8px 16px',
                fontSize: 14,
                fontWeight: 500,
                color: '#1a1a1a',
                textDecoration: 'none',
              }}
            >
              Home
            </a>
          </div>
          {error.digest && (
            <p style={{ fontFamily: 'ui-monospace, monospace', fontSize: 11, color: '#8a8a8a', margin: 0 }}>
              ref: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  )
}
